import axios from 'axios';

const buildTarget = process.env.BUILD_TARGET || 'development';
const allConfigs = {
  development: {
    apiUrl: 'http://localhost:31545/'
  },
  staging: {
    apiUrl: '/home/'
  },
  production: {
    apiUrl: '/home/'
  }
};

let configs = allConfigs[buildTarget];

const configPromise = Promise.all([
  axios.get(`${configs.apiUrl}api/getConfigs`)
    .then((resp) => {
      configs = { ...configs, ...resp.data };
    }),
  axios.get(`${configs.apiUrl}api/getMinMaxYears`)
    .then((resp) => {
      configs = { ...configs, ...resp.data };
    })
]).then(() => {
  window.configs = configs;
  return configs;
});

const getConfigs = () => configPromise;

export default getConfigs
